<template>
  <div :class="['chart-not-available', ifIsMop ? 'chart-p-mop' : 'chart-p-sop']" data-test="chartNotAvailable">
    <loading
      v-if="!fullPageLoading"
      :active="activeLoading"
      :color="'blue'"
      :is-full-page="false"
      :background-color="'inherit'"
      loader="spinner"
    ></loading>
    <span>{{ $t('common.notAvailable') }}</span>
  </div>
</template>

<script>
export default {
  props: {
    fullPageLoading: {
      type: Boolean,
    },
    activeLoading: {
      type: Boolean,
    },
    ifIsMop: {
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-not-available {
  text-align: center;
  background-color: #fff;
}
.chart-p-mop {
  padding: 5.7563rem;
}
.chart-p-sop {
  padding: 8.9625rem;
}
</style>
